var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-6"},[_c('v-btn',{staticClass:"mr-2",attrs:{"color":"primary"},on:{"click":_vm.addStaff}},[_c('v-icon',[_vm._v("mdi-account-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }